<template>
    <div class="evaluateCompanySearch">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div><img src="../../assets/img/index/title.png" alt="" style="margin: 10px auto 0;"></div>
                    <div><img src="../../assets/img/index/division.png" alt="" style="margin: 0 auto;width: 100%;"></div>
                    <div class="from">
                        <div class="line" style="width: 26%;">
                            <span class="label">企业名称: </span>
                            <el-input v-model="formInline.companyName" placeholder="企业名称" style="width: 320px;"></el-input>
                        </div>
                        <div class="line" style="width: 26%;">
                            <span class="label">证书编号: </span>
                            <el-input v-model="formInline.certificate" placeholder="证书编号" style="width: 320px;"></el-input>
                        </div>
                        <div class="line" style="width: 32%;">
                            <span class="label">验证码: </span>
                            <div @click="refreshCode" style="margin: 0 10px;cursor: pointer;" title="换一换">
                                <!--验证码组件-->
                                <dentify :identifyCode="identifyCode"></dentify>
                            </div>
                            <el-input v-model="formInline.code" placeholder="验证码" style="width: 160px;"></el-input>
                        </div>
                        <div class="line"><el-button type="primary" @click="submit">搜索</el-button></div>
                    </div>
                    <div class="table">
                        <el-table :data="tableData" style="width: 100%" border ref="refsTable" :header-cell-style="{'text-align': 'center'}">
                            <el-table-column prop="name" label="企业名称" align="center" width="260"></el-table-column>
                            <el-table-column prop="grade" label="信用等级" align="center"></el-table-column>
                            <el-table-column prop="certificateNumber" label="证书编号" align="center" width="180"></el-table-column>
                            <el-table-column prop="publishTime" label="颁发日期" align="center"></el-table-column>
                            <el-table-column prop="effectiveDate" label="有效期至" align="center"></el-table-column>
                            <el-table-column label="详细" align="center">
                                <template slot-scope="scope">
                                    <span style="color: #1A68E8;cursor: pointer;" @click="toEvaluateCompany(scope.row.id, '信用企业详情')">查看</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 分页 -->
                        <el-pagination  @current-change="currentChange"
                          background
                          :current-page="page"
                          layout="prev, pager, next, jumper"
                          next-text="下一页"
                          prev-text="上一页"
                          :total="total">
                        </el-pagination>
                        <div style="text-align: center;font-size: 14px;color: #666;margin-top: 10px;">最多显示50条,如需更多,请输入更精准的查询条件</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
import dentify from "../../components/dentify";
export default {
    name: 'evaluateCompanySearch',
    components: {
        publicHeaders,
        foot,
        dentify
    },
    data() {
        return {
            documentTitle: '',
            formInline: {
                companyName: '',
                certificate: '',
                code: ''
            },
            identifyCode: '',
            identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz", //随机串内容,从这里随机抽几个显示验证码
            tableData: [
                // {
                //     companyName: '法信公司',
                //     rank: 'AAA',
                //     code: '1202311119366404',
                //     date: '2023-09-07',
                //     validity: '2024-09-06',
                //     id: 'aaaaaa'
                // },
                // {
                //     companyName: '北京心智时代品牌管理有限公司',
                //     rank: 'AAA',
                //     code: '1202311119366404',
                //     date: '2023-09-07',
                //     validity: '2024-09-06',
                //     id: 'aaaaaa'
                // },
                // {
                //     companyName: '美黎教育有限公司',
                //     rank: 'AAA',
                //     code: '1202311119366404',
                //     date: '2023-09-07',
                //     validity: '2024-09-06',
                //     id: 'aaaaaa'
                // },
                // {
                //     companyName: '因特瑞思(北京)信息科技有限公司',
                //     rank: 'AAA',
                //     code: '1202311119366404',
                //     date: '2023-09-07',
                //     validity: '2024-09-06',
                //     id: 'aaaaaa'
                // },
                // {
                //     companyName: '北京志荣维拓科技有限公司',
                //     rank: 'AAA',
                //     code: '1202311119366404',
                //     date: '2023-09-07',
                //     validity: '2024-09-06',
                //     id: 'aaaaaa'
                // },
            ],
            total: 0,
            page: 1,
            isSearch: false,
        }
    },
    created() {
        window.scrollTo(0 ,0)
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle

        if (this.$route.query.searchName != undefined) {
            this.formInline.companyName = this.$route.query.searchName
        }
        this.getList()
    },
    mounted() {
        // 初始化验证码
        this.identifyCode = "";
        //参数：（1）随机串内容。（2）验证码显示位数
        this.makeCode(this.identifyCodes, 4);
    },
    methods: {
        // 前往详情
        toEvaluateCompany(item, title) {
        // console.log(item);
            this.$router.push({
                name: 'evaluateCompany',
                query: {
                    documentTitle: title,
                    id: item
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/evaluateCompany"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item, '_blank');
        },

        // 重置验证码
        refreshCode() {
          this.identifyCode = "";
          this.makeCode(this.identifyCodes, 4);
        },
        //获取验证码的值
        makeCode(o, l) {
          for (let i = 0; i < l; i++) {
            //通过循环获取字符串内随机几位
            this.identifyCode +=
              this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
          }
        },
        //随机数字：用于当角标拿字符串的值
        randomNum(min, max) {
          return Math.floor(Math.random() * (max - min) + min);
        },

        // 查询默认列表
        getList() {
            let _this = this
            let params = {
                param: '',
                page: _this.page,
                limit: 10,
            }
            api.getCreditCompany(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.tableData = data.data.data
                    _this.total = data.data.total
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 查询
        submit() {
            this.isSearch = true
            let _this = this
            // console.log(this.input);
            let params = {
                companyName: this.formInline.companyName,
                certificateNumber: this.formInline.certificate,
                page: _this.page,
                limit: 10
            }
            if (this.identifyCode == this.formInline.code) {
                _this.tableData = []
                api.getCreditCompany(params).then(res => {
                    let { data } = res
                    // console.log(data);
                    if (data.status == 200) {
                        _this.tableData = data.data.data
                        _this.total = data.data.total
                        this.refreshCode()
                    } else {
                        
                    }
                })
                .catch(error => {
                //   _this.$toast('网络错误，请检查网络')
                })
            } else {
                _this.$message.error('验证码错误')
            }

        },

        currentChange(val) {
            this.page = val;
            if (this.isSearch) {
                this.submit()
            } else {
                this.getList()
            }
        }
    }
}
</script>

<style lang="less" scoped>
.evaluateCompanySearch {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        /deep/ .el-table {
            font-size: 16px;
        }
        .left {
            margin-right: 5px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 800px;
                border: 1px solid #D9D9D9;
                margin-top: 10px;
                padding: 20px 0 50px;
                background: url('../../assets/img/index/watermark.png') no-repeat;
                background-position-x: center;
                .from {
                    margin: 0 40px;
                    padding: 20px 50px;
                    display: flex;
                    justify-content: space-between;
                    background-color: #F2F7FF;
                    /deep/ .el-input__inner {
                        height: 37px;
                        line-height: 37px;
                        border-radius: 1px;
                    }
                    /deep/ .el-button {
                        border-radius: 1px;
                        background-color: #1A68E8;
                        width: 94px;
                    }
                    .line {
                        display: flex;
                        justify-content: left;
                        align-items: center;
                        white-space: nowrap;
                        .label {
                            margin-right: 10px;
                            color: #000;
                            font-size: 20px;
                        }
                    }
                }
                .table {
                    margin: 30px 90px 0;
                    min-height: 480px;
                    /deep/ th {
                        border-color: #ddd;
                        background-color: #F6F6F6;
                        color: #000;
                        font-size: 18px;
                        font-weight: 700;
                    }
                    /deep/ td,
                    .el-table__cell,
                    tr  {
                        border-color: #ddd;
                    }
                    /deep/ .el-table tr {
                        font-size: 18px;
                        color: #111;
                    }
                    /deep/ .el-table .el-table__cell {
                        padding: 6px 0;
                    }
                    /deep/ .el-table .cell {
                        white-space: nowrap;
                    }
                    /deep/ .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
                        border-bottom: 1px solid #ddd;
                    }
                    /deep/ .el-pagination {
                        display: flex;
                        justify-content: center;
                        margin-top: 15px;
                    }
                    /deep/ .el-pager li {
                        background: #fff;
                        border: 1px solid #ddd;
                        border-radius: 1px;
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        width: 34px;
                    }
                    /deep/ .el-pager li:nth-of-type(n+2) {
                        border-left: none;
                    }
                    /deep/ .btn-next {
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-left: none;
                    }
                    /deep/ .btn-prev {
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-right: none;
                    }
                    /deep/ .el-pager li:not(.disabled).active {
                        background-color: #045FAF;
                    }
                }
            }
        }
    }
}
</style>